import { render, staticRenderFns } from "./formField.vue?vue&type=template&id=2b1e69a9&scoped=true"
import script from "./formField.vue?vue&type=script&lang=js"
export * from "./formField.vue?vue&type=script&lang=js"
import style0 from "./formField.vue?vue&type=style&index=0&id=2b1e69a9&prod&lang=scss"
import style1 from "./formField.vue?vue&type=style&index=1&id=2b1e69a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e69a9",
  null
  
)

export default component.exports